/*
 * Constants
 */
export const tiltSpeed = {
	rotateX: 1, // a relative rotation of -1deg to 1deg on the x-axis
	rotateY: -4  // a relative rotation of -3deg to 3deg on the y-axis
}

export const initTransform = {
	translateX: 0,
	translateY: 0,
	translateZ: 500, // How far into the room do we start ?
	rotateX: 0,
	rotateY: 0,
	rotateZ: 0
}

export const entranceTransition = { property: 'transform', speed: '0.4s', easing: 'ease' }